import React, { useCallback, useEffect, useRef } from "react";
import ReactResizeDetector from "react-resize-detector";
import shave from "shave";
import { htmlToReact, Paragraph as ParagraphType, ParagraphEntity } from "../processors";

export interface ParagraphProps extends ParagraphType {
    className?: string;
    truncate?: {
        height: (element: Element) => number;
    };
}
export const Paragraph: React.FC<ParagraphProps> = ({ text, footer, truncate, className, children }) => {
    const ref = useRef();

    const trun = useCallback(() => {
        const element = ref.current as Element;
        if (element && truncate) {
            const body = (element.getElementsByClassName("body") ?? [])[0];

            body && shave(body, truncate.height ? truncate.height(element) : element.clientHeight);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ref.current, truncate]);

    useEffect(() => {
        trun();
    }, [trun]);

    if (!truncate)
        return (
            <div className={className ?? ""}>
                {text?.value && <>{htmlToReact(text?.value)}</>}
                {children}
                {footer?.value && <>{htmlToReact(footer?.value)}</>}
            </div>
        );

    return (
        <div className={className ?? ""} ref={ref}>
            <div className="body" style={{ height: "100%" }}>
                {text?.value && <>{htmlToReact(text?.value)}</>}
                {children}
                {footer?.value && <>{htmlToReact(footer?.value)}</>}
            </div>
            <ReactResizeDetector handleWidth={true} handleHeight={true} onResize={trun} />
        </div>
    );
};

export interface ParagraphWithoutWrapperProps extends ParagraphEntity {}

export const ParagraphWithoutWrapper: React.FC<ParagraphWithoutWrapperProps> = ({ text, footer }) => {
    return (
        <>
            {text?.value && <>{htmlToReact(text?.value)}</>}
            {footer?.value && <>{htmlToReact(footer?.value)}</>}
        </>
    );
};
